import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";

import { GfxUtils, NodeType } from "../../../common/gfxUtils";
import { StepVisualizer } from "./stepVisualizer";
import { CreateSteps } from "./balconyCreationObjects";
import { CreateWithMeasurements } from "./balconyCreationMeas";

import { BalconyGroup, BalconyInfo, BalconyPanel } from "./balconyInfo";

enum StartCreationStep {
    None,
    Info,
    Method,
    Meas,
    Object
}

interface CreationProps {
    viewer: Autodesk.Viewing.GuiViewer3D;
    addBalcony: (apartment: string, level: number, line: string, panels: BalconyPanel[], drawPanels: boolean, meas: any) => void;
    removePanels: (panels: number[]) => void;
    removeMeasurements: () => Promise<void>;
    closeWizard: () => void;
    originalModelId: number;
    panelsModelId: number;
    gfxUtils: GfxUtils;
}

export function StartCreation(props: CreationProps) {
    const [step, setStep] = useState(StartCreationStep.Info);
    const [helpText, setHelpText] = useState("");

    const [apartment, setApartment] = useState("");
    const [level, setLevel] = useState("");
    const [line, setLine] = useState("");

    const [methodChecked, setMethodChecked] = useState(false);

    useEffect(() => {
        switch (step) {
            case StartCreationStep.Info:
                setHelpText("Fill in the apartment info");
                break;
            case StartCreationStep.Method:
                setHelpText("Choose a way to create a balcony (default: measurement)");
                break;
            default:
                setHelpText("This is an area for help texts");
        }
    }, [step])

    const methodChanged = () => setMethodChecked(!methodChecked);

    return (
        <div>
            {(step === StartCreationStep.Info || step === StartCreationStep.Method) &&
                <div id="steps-react" className="react-content m-1">
                    <div>
                        <div className="row pt-1 pb-2">
                            <div className="col d-flex justify-content-center">
                                <StepVisualizer steps={["Info", "Method"]} currentStep={step} />
                            </div>
                        </div>
                    </div>

                    <div className="row d-flex align-items-center justify-content-center mt-1 mb-2 border border-white" style={{ height: "50px" }}>
                        <span style={{ fontSize: "medium" }}>{helpText}</span>
                    </div>

                    {step === StartCreationStep.Info &&
                        <form className="sdAddBalcony">
                            <div className="form-row py-2 align-items-center justify-content-center">
                                <div className="form-group col-3">
                                    <input type="text" className="form-control" id="sdLine" placeholder="Line"
                                        value={line} onChange={evt => setLine(evt.target.value)} />
                                </div>
                                <div className="form-group col-3">
                                    <input type="number" className="form-control" id="sdLevel" placeholder="Level"
                                        value={level} onChange={evt => setLevel(evt.target.value)} />
                                </div>

                                <div className="form-group col-3">
                                    <input type="text" className="form-control" id="sdApart" placeholder="Apartment"
                                        value={apartment} onChange={evt => setApartment(evt.target.value)} />
                                </div>
                            </div>
                        </form>
                    }

                    {step === StartCreationStep.Method &&
                        <div className="row d-flex py-2 justify-content-center">
                            <div className="custom-control custom-switch">
                                <input type="checkbox" className="custom-control-input" id="methodSwitch"
                                    checked={methodChecked}
                                    onChange={methodChanged} />
                                <label className="custom-control-label" htmlFor="methodSwitch">Use object selection</label>
                            </div>
                        </div>
                    }

                    <div className="row align-items-center justify-content-between py-1">
                        <div className="col">
                            <button id="cancel" className="btn btn-secondary"
                                onClick={(e) => {
                                    props.closeWizard();
                                }}>
                                Cancel
                            </button>
                        </div>
                        <div className="col">
                            <button id="stop1" className="btn btn-primary float-right"
                                disabled={step == StartCreationStep.Info && (apartment.length == 0 || level.length == 0 || line.length == 0)}
                                onClick={async (e) => {
                                    setStep((prev) => prev + 1);
                                    switch (step) {
                                        case StartCreationStep.Info:
                                            break;
                                        case StartCreationStep.Method:
                                            setStep(methodChecked ? StartCreationStep.Object : StartCreationStep.Meas);
                                            break;
                                        default:
                                    }
                                }}>
                                Next
                            </button>
                        </div>
                    </div>

                </div>
            }

            {step === StartCreationStep.Meas &&
                <div>
                    <CreateWithMeasurements viewer={props.viewer} originalModelId={props.originalModelId}
                        panelsModelId={props.panelsModelId} apartment={apartment} level={Number(level)} line={line}
                        addBalcony={props.addBalcony} removePanels={props.removePanels}
                        removeMeasurements={props.removeMeasurements} closeWizard={props.closeWizard} />
                </div>
            }
            {step === StartCreationStep.Object &&
                <div>
                    <CreateSteps viewer={props.viewer} originalModelId={props.originalModelId} panelsModelId={props.panelsModelId}
                        apartment={apartment} level={Number(level)} line={line}
                        gfxUtils={props.gfxUtils} addBalcony={props.addBalcony}
                        removePanels={props.removePanels} closeWizard={props.closeWizard} />
                </div>
            }
        </div>
    );
}
